/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRotationsLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3c-1.958 0-3.278.44-4.813 1.486-.917.625-1.959 1.505-3.302 2.639L4 7.87V5H2v6h6V9H5.765l.533-.45c1.266-1.069 2.18-1.842 3.015-2.411C10.528 5.31 11.458 5 13 5a7 7 0 1 1-6.492 9.625l-1.853.75A9.003 9.003 0 0 0 22 12a9 9 0 0 0-9-9zm2 6a2 2 0 1 0-4 0v1h-1v6h6v-6h-1V9z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRotationsLock as RotationsLock };
